// DotMenu.tsx
import React, { useState, useRef, useEffect } from 'react';
import { ThreeDotsIcon } from '../assets/icons/Icons';

interface Option {
  label: string;
  icon: any;
  color?: string;
}

interface DotMenuProps {
  options: Option[];
  type?: "circle" | "normal";
  setSelected?: (option: string) => void;
  md?: boolean
}

const DotMenu: React.FC<DotMenuProps> = ({ options, setSelected, type = "normal", md = false }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleSetSelected = (option: string) => {
    if (setSelected) {
      setSelected(option);
    }
    setIsOpen(false)
  }

  return (
    <div onClick={e => e.stopPropagation()} className="relative" ref={menuRef}>
      {
        type === "circle" ?
        <div className="flex items-center justify-center cursor-pointer w-8 h-8 rounded-full bg-white" onClick={() => setIsOpen(!isOpen)}>
          <ThreeDotsIcon />
        </div>
          :
        <ThreeDotsIcon onClick={() => setIsOpen(!isOpen)} />
      }
      {isOpen && (
        <div className={`${md ? "w-[215px]" : "w-[250px]"} h-auto bg-white rounded-xl absolute right-0 shadow-[-10px_-10px_30px_4px_rgba(0,0,0,0.1),_8px_8px_25px_3px_rgba(45,78,255,0.15)] duration-75 animate-zoomIn z-50 ${type === "circle" ? "top-10" : "top-5"}  ${
          isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
        }`}>
          {options.map((option, index) => (
            <div key={index} onClick={() => handleSetSelected(option.label)} className="p-3.5 border-b border-[#EAE9EF] flex items-center justify-between cursor-pointer">
              <div className={`text-sm font-medium leading-[14px] ${option.color ? "text-[#FF542E]" : "text-[#0F0C18]"}`}>
                {option.label}
              </div>
              <option.icon className={`${option.color ? "text-[#FF542E]" : "text-[#9392A2]"}`} stroke={option.color ? "#FF542E" : "#9392A2"} fill={option.color ? "#FF542E" : "#9392A2"} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DotMenu;
